import { required, ResourceContextProvider, SimpleForm } from "react-admin";
import {
  useFormContext,
  type FieldValues,
  type SubmitHandler,
} from "react-hook-form";

import { BaseModal } from "@/components/modal";
import { MODULE_NAMES } from "@/constants/modules";
import { ReferenceSelectArrayInput } from "@/inputs/ReferenceSelectArrayInput";
import { ClientAppAllowedLandings } from "@/modules/clientApps/components/ClientAppAllowedLandings";

import { CampaignTdsFormToolbar } from "./CampaignTdsFormToolbar";
import { type CampaignTdsFormShape } from "./types";

export type CampaignTdsRecordsToCreate = {
  landings: string[];
  countrySet: string[];
  modelSet: string[];
  osSet: string[];
};

type Props = {
  isOpen: boolean;
  isPending?: boolean;
  withDates?: boolean;
  onClose: () => void;
  onSubmit: SubmitHandler<CampaignTdsRecordsToCreate>;
};

export const CampaignTdsCreateFormModal = ({
  isOpen,
  isPending,
  onClose,
  onSubmit,
}: Props) => {
  const { watch } = useFormContext<CampaignTdsFormShape>();
  const selectedClientAppId = watch("clientAppId");

  return (
    <BaseModal open={isOpen} title="Create Campaign TDS" onClose={onClose}>
      <ResourceContextProvider value={MODULE_NAMES.CAMPAIGN_TDS}>
        <SimpleForm
          disabled={isPending}
          onSubmit={onSubmit as SubmitHandler<FieldValues>}
          toolbar={<CampaignTdsFormToolbar />}
        >
          <ClientAppAllowedLandings
            selectedClientAppId={selectedClientAppId}
            validate={[required()]}
            source="landings"
          />
          <ReferenceSelectArrayInput
            module={MODULE_NAMES.COUNTRIES}
            source="countrySet"
            optionValue="code"
          />
          <ReferenceSelectArrayInput
            module={MODULE_NAMES.APPLE_MODELS}
            source="modelSet"
            optionText="title"
          />
          <ReferenceSelectArrayInput
            module={MODULE_NAMES.OS}
            source="osSet"
            optionText="title"
          />
        </SimpleForm>
      </ResourceContextProvider>
    </BaseModal>
  );
};
